import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { Tooltip } from "primereact/tooltip";
import { useAppContext } from "../../../../context/AppContext";
//components

export const Header = ({
  onSubmitReadjust,
  selectedCustomers,
  schedules

}) => {
  const { id } = useParams();
  const { state } = useLocation();
  const { permissions } = useAppContext();


  const items = [
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterprise/contractAdjustment/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Reajustar contrato
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };


  return (
    <div className="row p-0">
      <div className="col-xl-6">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="col-xl-6 text-end p-0">
        <div className="row justify-content-end pb-3">
          <div className="col-md-5">
            {schedules?.some(schedule => schedule.type === 'readjust_sale') && (
              <Tooltip
                position="bottom"
                target=".btn-disabled-tooltip"
                content="Não é possível confirmar correção porque já existe um reajuste em andamento."
              />
            )}
            {permissions && permissions.includes("32") && ( //Reajustar Contratos
              <div className="btn-disabled-tooltip" style={{ display: 'inline-block', width: '100%' }}>
                <Button
                  disabled={
                    selectedCustomers?.length === 0 ||
                    schedules?.some(schedule => schedule.type === 'readjust_sale')
                  }
                  rounded
                  severity="danger"
                  label="Confirmar Correção"
                  icon="fa fa-check"
                  onClick={() => onSubmitReadjust()}
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
            )}
          </div>



        </div>
      </div>
    </div>
  );
};
